/* eslint-disable no-use-before-define */

import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { makeStyles } from '@material-ui/core/styles';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles((theme) => ({
  input: {
    '&::placeholder': {
      color: '#FFF',
    },
  },
}))
export default function MultiSelect(props) {
  const classes = useStyles();

  // disablePortal=true, altrimenti nel mobile non si riesce a selezione le checkbox
    
  return (
    <Autocomplete
      multiple
      size="small"
      disablePortal={true}  
      options={props.lists}
      disableCloseOnSelect
      getOptionLabel={(option) => option}
      value={props.values}
      onChange={(event, newValue) => {
        props.setvalue(newValue,props.type)
      }}
      style={{background:'#FFF',padding:20}}
      renderOption={(option, { selected }) => {
      return(
        <React.Fragment>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{ marginRight: 8 }}
          checked={selected}
        />
        {option}
      </React.Fragment>
      )
        
      
}}
      renderInput={(params) => (
        <TextField 
        InputProps={{
          classes: { input: classes.input}
        }}
        style={{color:'#FFF'}}
        {...params} variant="outlined" label="" placeholder={props.type} />
      )}
      id={props.id+Math.random()}
    />
  );
}
